<script lang="ts" setup>
import WishlistItem from '@/api/WishlistItem'
import useAuthStore from '@/stores/auth'
import useWishlistStore from '@/stores/wishlist'
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const authStore = useAuthStore()
const wishlistStore = useWishlistStore()

onMounted(() => {
  fetchWishlistItems()
})

const fetchWishlistItems = async () => {
  if (route.name !== 'account.wishlist' && authStore.isAuthenticated) {
    wishlistStore.items = await WishlistItem.get()
  }
}
</script>

<template>
  <div class="hidden"></div>
</template>
